import { render, staticRenderFns } from "./newAccountModel.vue?vue&type=template&id=32eaa790&scoped=true"
import script from "./newAccountModel.vue?vue&type=script&lang=js"
export * from "./newAccountModel.vue?vue&type=script&lang=js"
import style0 from "./newAccountModel.vue?vue&type=style&index=0&id=32eaa790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eaa790",
  null
  
)

export default component.exports